<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/114/title-bg.png" alt="" />
            <div class="technological-process">
                <div class="rhtj mar-t2">
                    <img class="top" src="./../assets/imgs/114/title-1.png" alt="" />
                    <div class="content">
                        与我县社会工作有关企业或机构签订用工协议的社工人才。
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/114/title-2.png" alt="" />
                    <div class="content">
                        与我县社会工作有关企业或机构签订1年以上用工协议，且每年在我县从事社工工作9个月以上的社工员、助理社会工作师、社会工作师、高级社会工作师或社工专业专科、本科、研究生、博士学历。
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/114/title-3.png" alt="" />
                    <div class="content">
                        对社工员、助理社会工作师、社会工作师、高级社会工作师或社工专业专科、本科、研究生、博士学历，分别给予每年1200元、1500元、1800元、2400元资助（与村&lt社区>专职干部中的社工专业人才政策不重复享受）。
                    </div>
                </div>
                <div class="gmlc">
                    <img class="top" src="./../assets/imgs/114/title-4.png" alt="" />
                    <div class="content">
                        <div class="des mar-t3">
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">1</div>
                                    <div class="line-title">申报阶段</div>
                                </div>
                                <div class="line-content">
                                    <div style="font-weight: bold; font-size: 0.27rem;">
                                        人才（团队）自主申报，将申报材料交至县民政局慈社科 ，申报材料应包括正式用工协议、社保证明、资质证明文件。
                                    </div>
                                    <div style="margin-top: 0.22rem;width: 100%;height:0.02rem;background-color: #3D5AA3;"></div>
                                    <div style="margin-top: 0.22rem;">
                                        <div>所需资料：</div>
                                        <div>1. 人才（团队）补助申请承诺书；</div>
                                        <div>2. 工作证明；</div>
                                        <div>3.身份证复印件；</div>
                                        <div>4.资金补助审批表；</div>
                                        <div>5.资质证明文件；</div>
                                        <div>6.社保证明；</div>
                                        <div>7.合同；</div>
                                        <div>8.银行卡复印件。</div>
                                    </div>
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">2</div>
                                    <div class="line-title">审核阶段</div>
                                </div>
                                <div class="line-content">
                                    <div style="font-weight: bold;font-size: 0.27rem;">
                                        县民政局组织开展审核。
                                    </div>
                                    <div style="margin-top: 0.22rem;width: 100%;height:0.02rem;background-color: #3D5AA3;"></div>
                                    <div style="margin-top: 0.22rem;">
                                        <div>所需资料：</div>
                                        <div>1. 人才（团队）补助申请承诺书；</div>
                                        <div>2. 工作证明；</div>
                                        <div>3.身份证复印件；</div>
                                        <div>4.资金补助审批表；</div>
                                        <div>5.资质证明文件；</div>
                                        <div>6.社保证明；</div>
                                        <div>7.合同；</div>
                                        <div>8.银行卡复印件。</div>
                                    </div>
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line-top">
                                    <div class="line-num">3</div>
                                    <div class="line-title">部门联审</div>
                                </div>
                                <div class="line-content">
                                    <div style="font-weight: bold;font-size: 0.27rem;">
                                        县民政局将审核结果报县委组织部审议，面向社会进行为期15个工作日公示。如内容涉密，按照涉密流程公示。若公示无异议，兑现相关激励。
                                    </div>
                                    <div style="margin-top: 0.22rem;width: 100%;height:0.02rem;background-color: #3D5AA3;"></div>
                                    <div style="margin-top: 0.22rem;">
                                        <div>所需资料：</div>
                                        <div>审核认定花名册</div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="sxcl" style="margin-top: 0.8rem;">
                    <img class="top" src="./../assets/imgs/114/title-5.png" alt="" />
                    <div class="content" style="font-weight: bold;font-size: 0.3rem;">
                        依据每年度通知时间确定
                    </div>
                </div>

                <div class="contact">
                    <img class="top" src="./../assets/imgs/113/title-6.png" alt="" />
                    <div class="content">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-68533605">028-68533605</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            金堂县民政局慈社科
                        </div>
                        <div class="unit">
                            <span class="label">联系地址：</span>
                            金堂县迎宾大道一段388号第二办公区4楼406办公室
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- <call phone="028-83221725"></call> -->
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },

    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;

    .top-img {
        width: 7.26rem;
        height: 5.6rem;
    }

    .technological-process {
        transform: translateY(-1.9rem);

        .rhtj {
            position: relative;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                font-size: 0.26rem;
                font-weight: 500;
                color: #4e4e4e;
                line-height: 0.44rem;
                text-align: left;
            }
        }

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;
            }
        }


        .gmlc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.55rem auto;
                padding: 0 0.33rem 0.35rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem;
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;

                    .line-item {
                        font-size: 0.26rem;
                        position: relative;
                        z-index: 3;

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 100%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .line-title {
                            font-size: 0.3rem;
                            font-weight: bold;
                            color: #3d5aa3;
                        }

                        .line-top {
                            display: flex;
                            width: 3.31rem;
                            height: 0.49rem;
                            background-image: url(../assets/imgs/25/label.png);
                            background-size: 100% 100%;
                            z-index: 99;
                            display: flex;
                            align-items: center;
                            box-sizing: border-box;
                            padding-left: 0.08rem;

                            .line-num {
                                width: 0.39rem;
                                height: 0.39rem;
                                background: #fff;
                                color: #3d5aa3;
                                display: inline-flex;
                                border-radius: 50%;
                                justify-content: center;
                                align-items: center;
                                margin-right: 0.14rem;
                                position: relative;
                                z-index: 3;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 0.28rem;
                                font-weight: bold;
                            }
                        }

                        .line-content {
                            //   border-left: 0.02rem dashed #739bfe;
                            padding-bottom: 0.32rem;
                            margin-left: 0.2rem;
                            padding-left: 0.32rem;
                            padding-top: 0.15rem;
                            word-break: break-all;
                            line-height: 0.44rem;
                        }
                    }
                }
            }
        }

        .fund {
            position: relative;
            margin-top: 0.8rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

                .text {
                    background-color: #fff;
                    box-sizing: border-box;
                    padding: 0.42rem 0.25rem;
                    font-size: 0.26rem;
                    border-radius: 0.26rem;
                    color: #4e4e4e;
                }
            }
        }


    }
}
</style>
